import { FC, cloneElement, Children, ComponentProps } from 'react';
import classnames from 'classnames';

import { Button } from '@hh.ru/magritte-ui-button';
import { ButtonStackProps } from '@hh.ru/magritte-ui-button-stack/types';

import styles from './button-stack.less';

export const ButtonStack: FC<ButtonStackProps> = ({ children, orientation = 'auto' }) => {
    return (
        <div className={classnames(styles.buttonStack, styles[`button-stack_${orientation}`])}>
            {Children.map(children, (child, index) => (
                <div key={index} className={classnames({ [styles.buttonStackItem]: orientation !== 'vertical' })}>
                    {cloneElement(child, { stretched: true } as ComponentProps<typeof Button>)}
                </div>
            ))}
        </div>
    );
};
